// @ts-nocheck
import { chain } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { LOCAL_STORAGE_KEY } from "@store/Framework/Services/FlyoutCampaignService";
import { addToStartOfChain, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const removeCampaignAsShownInSession = createChainHandler("RemoveCampaignAsShownInSession", chain, () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
});

addToStartOfChain(chain, removeCampaignAsShownInSession);
